import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../../../config/ApiConfig';
import DefaultModal from './DefaultModal';
import useDefaultModal from '../hooks/useDefaultModal';
import TelefoneMaskInput from '../masks/TelefoneMaskInput';
import CelularMaskInput from '../masks/CelularMaskInput';
import CEPMaskInput from '../masks/CEPMaskInput';
import { unformatTelefone, formatTelefone } from '../../utils/telefoneUtils';
import { unformatCelular, formatCelular } from '../../utils/celularUtils';
import { unformatCEP, formatCEP } from '../../utils/cepUtils';
import { formatCPF } from '../../utils/cpfUtils';
import { formatCNPJ } from '../../utils/cnpjUtils';

import CnaePicker from './CnaePicker';
import BancoPicker from './BancoPicker';
import NaturezaJuridicaPicker from './NaturezaJuridicaPicker';
import DataMaskInput from '../masks/DataMaskInput';

function normalizeString(str) {
  return (str || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toUpperCase();
}

function FornecedorModal({ show, fornecedor, onClose, onSave }) {
  const [formData, setFormData] = useState({
    cpfOrCnpj: '',
    nome: '',
    tipo: 'PJ',
    email: '',
    telefone: '',
    celular: '',
    logrNome: '',
    logrNum: '',
    logrCompl: '',
    logrBairro: '',
    logrCep: '',
    logrCidade: '',
    logrUf: '',
    banco: '',
    agencia: '',
    conta: '',
    estadoCivil: '',
    dataNascimento: '',
    sexo: '',
    nomePai: '',
    nomeMae: '',
    escolaridade: '',
    rgNum: '',
    rgExpedidor: '',
    rgUf: '',
    nacionalidade: '',
    porteEmpresa: '',
    nomeFantasia: '',
    inscricaoEstadual: '',
    inscricaoMunicipal: '',
    idCnae: '',
    idNaturezaJuridica: '',
  });
  const [cidades, setCidades] = useState([]);
  const [validated, setValidated] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingFornecedor, setLoadingFornecedor] = useState(false);
  const [isBuscandoCnpj, setIsBuscandoCnpj] = useState(false);
  const [cnaes, setCnaes] = useState([]);
  const [cnaesLoading, setCnaesLoading] = useState(false);
  const [showCnaePicker, setShowCnaePicker] = useState(false);
  const [showBancoPicker, setShowBancoPicker] = useState(false);
  const [showNaturezaJuridicaPicker, setShowNaturezaJuridicaPicker] = useState(false);
  const [emissores, setEmissores] = useState([]);
  const [bancos, setBancos] = useState([]);
  const [naturezas, setNaturezas] = useState([]);
  const [naturezasLoading, setNaturezasLoading] = useState(false);
  const token = localStorage.getItem('token');
  const vinculo = JSON.parse(localStorage.getItem('vinculo'));
  const { setDefaultModal, showDefaultModal } = useDefaultModal();

  function flattenExtension(fornecedor) {
    const raw = fornecedor.cpfOrCnpj || '';
    const formatted = fornecedor.tipo === 'PF' ? formatCPF(raw) : fornecedor.tipo === 'PJ' ? formatCNPJ(raw) : raw;
    const base = {
      cpfOrCnpj: formatted,
      nome: fornecedor.nome || '',
      tipo: fornecedor.tipo || 'PJ',
      email: fornecedor.email || '',
      telefone: fornecedor.telefone || '',
      celular: fornecedor.celular || '',
      logrNome: fornecedor.logrNome || '',
      logrNum: fornecedor.logrNum || '',
      logrCompl: fornecedor.logrCompl || '',
      logrBairro: fornecedor.logrBairro || '',
      logrCep: fornecedor.logrCep || '',
      logrCidade: fornecedor.logrCidade || '',
      logrUf: fornecedor.logrUf || '',
      banco: fornecedor.banco || '',
      agencia: fornecedor.agencia || '',
      conta: fornecedor.conta || '',
    };
    if (fornecedor.dadosPF) {
      base.estadoCivil = fornecedor.dadosPF.estadoCivil || '';
      base.dataNascimento = fornecedor.dadosPF.dataNascimento || '';
      base.sexo = fornecedor.dadosPF.sexo || '';
      base.nomePai = fornecedor.dadosPF.nomePai || '';
      base.nomeMae = fornecedor.dadosPF.nomeMae || '';
      base.escolaridade = fornecedor.dadosPF.escolaridade || '';
      base.rgNum = fornecedor.dadosPF.rgNum || '';
      base.rgExpedidor = fornecedor.dadosPF.rgExpedidor || '';
      base.rgUf = fornecedor.dadosPF.rgUf || '';
      base.nacionalidade = fornecedor.dadosPF.nacionalidade || '';
      base.profissao = fornecedor.dadosPF.profissao || '';
    }
    if (fornecedor.dadosPJ) {
      base.porteEmpresa = fornecedor.dadosPJ.porteEmpresa || '';
      base.nomeFantasia = fornecedor.dadosPJ.nomeFantasia || '';
      base.idCnae = fornecedor.dadosPJ.atividadePrincipal || '';
      base.inscricaoEstadual = fornecedor.dadosPJ.inscricaoEstadual || '';
      base.inscricaoMunicipal = fornecedor.dadosPJ.inscricaoMunicipal || '';
      base.idNaturezaJuridica = fornecedor.dadosPJ.idNaturezaJuridica || '';
    }
    return base;
  }

  const emptyForm = {
    cpfOrCnpj: '',
    nome: '',
    tipo: 'PJ',
    email: '',
    telefone: '',
    celular: '',
    logrNome: '',
    logrNum: '',
    logrCompl: '',
    logrBairro: '',
    logrCep: '',
    logrCidade: '',
    logrUf: '',
    banco: '',
    agencia: '',
    conta: '',
    estadoCivil: '',
    dataNascimento: '',
    sexo: '',
    nomePai: '',
    nomeMae: '',
    escolaridade: '',
    rgNum: '',
    rgExpedidor: '',
    rgUf: '',
    nacionalidade: '',
    profissao: '',
    porteEmpresa: '',
    nomeFantasia: '',
    idCnae: '',
    idNaturezaJuridica: '',
    inscricaoEstadual: '',
    inscricaoMunicipal: '',
  };

  useEffect(() => {
    if (!show) return;
    setValidated(false);

    // Carregar dados auxiliares (sempre)
    setCnaesLoading(true);
    axios.get(API_BASE_URL.CNAE, { headers: { Authorization: `Bearer ${token}` } })
      .then(result => setCnaes(result.data))
      .catch(error => {
        console.error('Erro ao carregar CNAEs:', error);
        showDefaultModal('error', `Erro ao carregar CNAEs (${error.response?.status || error.message}).`);
      })
      .finally(() => setCnaesLoading(false));

    axios.get(API_BASE_URL.EMISSOR, { headers: { Authorization: `Bearer ${token}` } })
      .then(result => setEmissores(result.data))
      .catch(error => console.error('Erro ao carregar emissores:', error));

    axios.get(API_BASE_URL.BANCO, { headers: { Authorization: `Bearer ${token}` } })
      .then(result => setBancos(result.data))
      .catch(error => console.error('Erro ao carregar bancos:', error));

    setNaturezasLoading(true);
    axios.get(API_BASE_URL.NATUREZA_JURIDICA, { headers: { Authorization: `Bearer ${token}` } })
      .then(result => setNaturezas(result.data))
      .catch(error => console.error('Erro ao carregar naturezas juridicas:', error))
      .finally(() => setNaturezasLoading(false));

    if (fornecedor) {
      // Edição: busca o fornecedor completo por ID
      setLoadingFornecedor(true);
      axios.get(`${API_BASE_URL.FORNECEDOR}/${fornecedor.idEntidade}/${fornecedor.cpfOrCnpj}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
        .then(result => {
          const full = result.data;
          console.log('Full fornecedor loaded:', {
            tipo: full.tipo,
            hasDadosPF: !!full.dadosPF,
            dadosPF: full.dadosPF,
            hasDadosPJ: !!full.dadosPJ,
            dadosPJ: full.dadosPJ,
          });
          if (full.logrUf) {
            axios.get(`${API_BASE_URL.MUNICIPIO}/uf/${full.logrUf}`, {
              headers: { Authorization: `Bearer ${token}` },
            })
              .then(cities => setCidades(cities.data))
              .catch(() => setCidades([]));
          }
          setFormData(flattenExtension(full));
        })
        .catch(() => {
          setFormData(flattenExtension(fornecedor));
        })
        .finally(() => setLoadingFornecedor(false));
    } else {
      setFormData({ ...emptyForm });
      setCidades([]);
    }
  }, [show, fornecedor, token]);

  useEffect(() => {
    if (formData.logrUf) {
      axios
        .get(`${API_BASE_URL.MUNICIPIO}/uf/${formData.logrUf}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then(result => {
          setCidades(result.data);
        })
        .catch(error => {
          console.error('Erro ao carregar cidades:', error);
        });
    } else {
      setCidades([]);
      setFormData(prev => ({
        ...prev,
        logrCidade: '',
      }));
    }
  }, [formData.logrUf, token]);

  const handleChange = e => {
    const { name, value } = e.target;

    if (name === 'telefone') {
      const cleaned = unformatTelefone(value);
      setFormData(prev => ({ ...prev, [name]: cleaned }));
      return;
    }

    if (name === 'celular') {
      const cleaned = unformatCelular(value);
      setFormData(prev => ({ ...prev, [name]: cleaned }));
      return;
    }

    if (name === 'logrCep') {
      const cleaned = unformatCEP(value);
      setFormData(prev => ({ ...prev, [name]: cleaned }));
      return;
    }

    if (name === 'cpfOrCnpj') {
      const cleaned = value.replace(/\D/g, '');
      let formatted = cleaned;

      if (formData.tipo === 'PF' && cleaned.length <= 11) {
        formatted = cleaned
          .replace(/(\d{3})(\d)/, '$1.$2')
          .replace(/(\d{3})(\d)/, '$1.$2')
          .replace(/(\d{3})(\d{1,2})$/, '$1-$2');
      } else if (formData.tipo === 'PJ' && cleaned.length <= 14) {
        formatted = cleaned
          .replace(/(\d{2})(\d)/, '$1.$2')
          .replace(/(\d{3})(\d)/, '$1.$2')
          .replace(/(\d{3})(\d)/, '$1/$2')
          .replace(/(\d{4})(\d{1,2})$/, '$1-$2');
      }

      setFormData(prev => ({ ...prev, [name]: formatted }));
    } else {
      setFormData(prev => ({ ...prev, [name]: value }));
    }
  };

  const handleTipoChange = e => {
    setFormData(prev => ({
      ...prev,
      tipo: e.target.value,
      cpfOrCnpj: '',
      estadoCivil: '',
      dataNascimento: '',
      sexo: '',
      nomePai: '',
      nomeMae: '',
      escolaridade: '',
      rgNum: '',
      rgExpedidor: '',
    rgUf: '',
    nacionalidade: '',
    profissao: '',
    porteEmpresa: '',
      nomeFantasia: '',
      idCnae: '',
      idNaturezaJuridica: '',
      inscricaoEstadual: '',
      inscricaoMunicipal: '',
    }));
  };

  function stripMask(value) {
    return value ? value.replace(/\D/g, '') : '';
  }

  function normalizePorte(porte) {
    if (!porte) return '';
    const p = porte.toString().toUpperCase().trim();
    if (p === 'MICRO EMPRESA' || p === 'MICROEMPRESA') return 'ME';
    if (p === 'MEI') return 'MEI';
    if (p === 'EMPRESA DE PEQUENO PORTE') return 'EPP';
    if (p === 'DEMAIS') return 'DEMAIS';
    return p;
  }

  function buildExtensionPayload(formData) {
    console.log('buildExtensionPayload input:', {
      tipo: formData.tipo,
      estadoCivil: formData.estadoCivil,
      dataNascimento: formData.dataNascimento,
      sexo: formData.sexo,
      nomePai: formData.nomePai,
      nomeMae: formData.nomeMae,
      escolaridade: formData.escolaridade,
      rgNum: formData.rgNum,
      rgExpedidor: formData.rgExpedidor,
      rgUf: formData.rgUf,
      nacionalidade: formData.nacionalidade,
      profissao: formData.profissao,
      porteEmpresa: formData.porteEmpresa,
      nomeFantasia: formData.nomeFantasia,
      idCnae: formData.idCnae,
      inscricaoEstadual: formData.inscricaoEstadual,
      inscricaoMunicipal: formData.inscricaoMunicipal,
    });
    const payload = { ...formData };
    if (formData.tipo === 'PF') {
      const temPFDados = formData.estadoCivil || formData.dataNascimento || formData.sexo
        || formData.nomePai || formData.nomeMae || formData.escolaridade
        || formData.rgNum || formData.rgExpedidor || formData.rgUf || formData.nacionalidade || formData.profissao;
      payload.dadosPF = temPFDados ? {
        estadoCivil: formData.estadoCivil || null,
        dataNascimento: formData.dataNascimento || null,
        sexo: formData.sexo || null,
        nomePai: formData.nomePai || null,
        nomeMae: formData.nomeMae || null,
        escolaridade: formData.escolaridade || null,
        rgNum: formData.rgNum || null,
        rgExpedidor: formData.rgExpedidor || null,
        rgUf: formData.rgUf || null,
        nacionalidade: formData.nacionalidade || null,
        profissao: formData.profissao || null,
      } : null;
      payload.dadosPJ = null;
    } else if (formData.tipo === 'PJ') {
      const temPJDados = formData.porteEmpresa || formData.nomeFantasia || formData.idCnae
        || formData.inscricaoEstadual || formData.inscricaoMunicipal || formData.idNaturezaJuridica;
      payload.dadosPJ = temPJDados ? {
        porteEmpresa: formData.porteEmpresa || null,
        nomeFantasia: formData.nomeFantasia || null,
        atividadePrincipal: formData.idCnae || null,
        inscricaoEstadual: formData.inscricaoEstadual || null,
        inscricaoMunicipal: formData.inscricaoMunicipal || null,
        idNaturezaJuridica: formData.idNaturezaJuridica || null,
      } : null;
      payload.dadosPF = null;
    }
    delete payload.estadoCivil;
    delete payload.dataNascimento;
    delete payload.sexo;
    delete payload.nomePai;
    delete payload.nomeMae;
    delete payload.escolaridade;
    delete payload.rgNum;
    delete payload.rgExpedidor;
    delete payload.rgUf;
    delete payload.nacionalidade;
    delete payload.profissao;
    delete payload.porteEmpresa;
    delete payload.nomeFantasia;
    delete payload.idCnae;
    delete payload.idNaturezaJuridica;
    delete payload.inscricaoEstadual;
    delete payload.inscricaoMunicipal;
    console.log('buildExtensionPayload output:', {
      dadosPF: payload.dadosPF,
      dadosPJ: payload.dadosPJ,
    });
    return payload;
  }

  async function handleBuscarCnpj() {
    const cnpjNum = stripMask(formData.cpfOrCnpj);

    if (formData.tipo === 'PJ' && cnpjNum.length !== 14) {
      showDefaultModal('error', 'Digite um CNPJ válido (14 dígitos) antes de buscar.');
      return;
    }
    if (formData.tipo === 'PF' && cnpjNum.length !== 11) {
      showDefaultModal('error', 'Digite um CPF válido (11 dígitos) antes de buscar.');
      return;
    }

    setIsBuscandoCnpj(true);
    try {
      const r = await axios.get(`${API_BASE_URL.CNPJ_PROXY}/${cnpjNum}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const d = typeof r.data === 'string' ? JSON.parse(r.data) : r.data;

      if (d.status === 'ERROR') {
        showDefaultModal('error', d.message || 'CPF/CNPJ não encontrado.');
        return;
      }

      let cidadeReceita = d.municipio || '';
      const ufReceita = d.uf || '';

      let cidadesParaMatch = cidades;
      if (ufReceita && ufReceita !== formData.logrUf) {
        try {
          const resCidades = await axios.get(`${API_BASE_URL.MUNICIPIO}/uf/${ufReceita}`, { headers: { Authorization: `Bearer ${token}` } });
          cidadesParaMatch = resCidades.data || [];
          setCidades(cidadesParaMatch);
        } catch (_) { cidadesParaMatch = []; }
      }

      let cidadeBanco = cidadesParaMatch.find(
        c => c.nome && cidadeReceita && normalizeString(c.nome) === normalizeString(cidadeReceita)
      );

      setFormData(f => ({
        ...f,
        nome: d.nome || f.nome,
        nomeFantasia: d.fantasia || f.nomeFantasia,
        email: d.email || f.email,
        telefone: d.telefone || f.telefone,
        logrNome: d.logradouro || f.logrNome,
        logrNum: d.numero || f.logrNum,
        logrCompl: d.complemento || f.logrCompl,
        logrBairro: d.bairro || f.logrBairro,
        logrCep: (d.cep || '').replace(/\D/g, '') || f.logrCep,
        logrUf: ufReceita || f.logrUf,
        logrCidade: cidadeBanco ? cidadeBanco.nome : f.logrCidade,
        porteEmpresa: normalizePorte(d.porte) || f.porteEmpresa,
        idCnae: (d.atividade_principal?.[0]?.code || '').replace(/\D/g, '') || f.idCnae,
        idNaturezaJuridica: (d.natureza_juridica || '').split(' - ')[0].trim() || f.idNaturezaJuridica,
      }));

      showDefaultModal('success', 'Dados carregados com sucesso!');
    } catch (err) {
      const status = err?.response?.status;
      if (status === 429) {
        showDefaultModal('error', 'Limite de consultas atingido. Aguarde 1 minuto e tente novamente.');
      } else if (status === 400) {
        showDefaultModal('error', 'CPF/CNPJ inválido ou não encontrado.');
      } else {
        showDefaultModal('error', `Erro ao consultar CPF/CNPJ${status ? ` (${status})` : ''}. Tente novamente em instantes.`);
      }
    } finally {
      setIsBuscandoCnpj(false);
    }
  }

  const handleSubmit = async e => {
    e.preventDefault();

    if (!formData.cpfOrCnpj || !formData.nome || !formData.tipo) {
      setValidated(true);
      return;
    }

    setLoading(true);

    const cleanedCpfOrCnpj = formData.cpfOrCnpj.replace(/\D/g, '');
    let payload = buildExtensionPayload(formData);
    payload.cpfOrCnpj = cleanedCpfOrCnpj;
    payload.idEntidade = vinculo.idEntidade;

    try {
      if (fornecedor) {
        payload.idFornecedor = fornecedor.idFornecedor;
        await axios.put(
          `${API_BASE_URL.FORNECEDOR}/${vinculo.idEntidade}/${fornecedor.cpfOrCnpj}`,
          payload,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        if (onSave) onSave();
        if (onClose) onClose();
        showDefaultModal('success', 'Fornecedor atualizado com sucesso!');
      } else {
        await axios.post(API_BASE_URL.FORNECEDOR, payload, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (onSave) onSave();
        if (onClose) onClose();
        showDefaultModal('success', 'Fornecedor cadastrado com sucesso!');
      }
    } catch (error) {
      console.error('Erro ao salvar fornecedor:', error);
      showDefaultModal('error', 'Erro ao salvar fornecedor. Verifique os dados e tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  if (!show) return null;

  const ufs = [
    'AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MT', 'MS',
    'MG', 'PA', 'PB', 'PR', 'PE', 'PI', 'RJ', 'RN', 'RS', 'RO', 'RR', 'SC',
    'SP', 'SE', 'TO'
  ];

  return (
    <>
      <div
        className="modal show d-block"
        tabIndex="-1"
        style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
      >
        <div className="modal-dialog modal-lg" style={{ maxWidth: '95vw', height: '90vh' }}>
          <div className="modal-content h-100 overflow-hidden">
            <div
              className="modal-header text-white"
              style={{
                background:
                  'linear-gradient(45deg, rgb(7, 29, 65) 0%, rgba(29, 100, 216, 1) 100%)',
                padding: '0.5rem 1rem',
                borderTopLeftRadius: '0.5rem',
                borderTopRightRadius: '0.5rem',
                border: 'none',
              }}
            >
              <h6 className="modal-title mb-0">
                <i className="bi bi-shop me-2"></i>
                {fornecedor ? 'Editar Fornecedor' : 'Novo Fornecedor'}
              </h6>
              <button
                type="button"
                className="btn-close btn-close-white"
                onClick={onClose}
                disabled={loading}
                title="Fechar"
              ></button>
            </div>
            <div className="modal-body" style={{ overflowY: 'auto' }}>
              <form onSubmit={handleSubmit} noValidate>
                <h6 className="text-primary mb-1">
                  <i className="bi bi-person-badge me-2"></i>
                  Dados Principais
                </h6>

                <div className="row gx-2">
                  <div className="col-md-2">
                    <div className="mb-2">
                      <label className="form-label small fw-semibold">
                        Tipo <span className="text-danger">*</span>
                      </label>
                      <select
                        className={`form-select form-select-sm ${validated && !formData.tipo ? 'is-invalid' : ''}`}
                        name="tipo"
                        value={formData.tipo}
                        onChange={handleTipoChange}
                        disabled={loading || !!fornecedor}
                      >
                        <option value="">Selecione...</option>
                        <option value="PF">Pessoa Física</option>
                        <option value="PJ">Pessoa Jurídica</option>
                      </select>
                      {validated && !formData.tipo && (
                        <div className="invalid-feedback">
                          Por favor, selecione o tipo.
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="mb-2">
                      <label className="form-label small fw-semibold">
                        {formData.tipo === 'PF' ? 'CPF' : formData.tipo === 'PJ' ? 'CNPJ' : 'CPF/CNPJ'} <span className="text-danger">*</span>
                      </label>
                      <div className="input-group input-group-sm">
                        <input
                          type="text"
                          className={`form-control form-control-sm ${validated && !formData.cpfOrCnpj ? 'is-invalid' : ''}`}
                          name="cpfOrCnpj"
                          value={formData.cpfOrCnpj}
                          onChange={handleChange}
                          maxLength={formData.tipo === 'PF' ? 14 : 18}
                          placeholder={formData.tipo === 'PF' ? '000.000.000-00' : formData.tipo === 'PJ' ? '00.000.000/0000-00' : 'Selecione o tipo primeiro'}
                          disabled={loading || !formData.tipo}
                          readOnly={!!fornecedor}
                        />
                        {formData.tipo === 'PJ' && (
                          <button
                            type="button"
                            className="btn btn-outline-primary btn-sm"
                            onClick={handleBuscarCnpj}
                            disabled={loading || isBuscandoCnpj || !formData.cpfOrCnpj}
                            title="Buscar dados na Receita Federal"
                          >
                            <i className="bi bi-search"></i>
                          </button>
                        )}
                      </div>
                      {validated && !formData.cpfOrCnpj && (
                        <div className="invalid-feedback">
                          Por favor, informe o {formData.tipo === 'PF' ? 'CPF' : 'CNPJ'}.
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-7">
                    <div className="mb-2">
                      <label className="form-label small fw-semibold">
                        Nome <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className={`form-control form-control-sm ${validated && !formData.nome ? 'is-invalid' : ''}`}
                        name="nome"
                        value={formData.nome}
                        onChange={handleChange}
                        maxLength={100}
                        placeholder="Nome do fornecedor"
                        disabled={loading}
                      />
                      {validated && !formData.nome && (
                        <div className="invalid-feedback">
                          Por favor, informe o nome.
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                {formData.tipo === 'PF' && (
                  <>
                    <h6 className="text-primary mb-2 mt-3">
                      <i className="bi bi-person-lines-fill me-2"></i>
                      Dados da Pessoa Física
                    </h6>

                    <div className="row gx-2">
                      <div className="col-md-3">
                        <div className="mb-2">
                          <label className="form-label small fw-semibold">Data de Nascimento</label>
                          <DataMaskInput
                            value={formData.dataNascimento}
                            onChange={e => handleChange({
                              target: {
                                name: 'dataNascimento',
                                value: e.target.value,
                              },
                            })}
                            disabled={loading}
                          />
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="mb-2">
                          <label className="form-label small fw-semibold">Sexo</label>
                          <select
                            className="form-select form-select-sm"
                            name="sexo"
                            value={formData.sexo}
                            onChange={handleChange}
                            disabled={loading}
                          >
                            <option value="">Selecione...</option>
                            <option value="MASCULINO">Masculino</option>
                            <option value="FEMININO">Feminino</option>
                          </select>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="mb-2">
                          <label className="form-label small fw-semibold">Estado Civil</label>
                          <select
                            className="form-select form-select-sm"
                            name="estadoCivil"
                            value={formData.estadoCivil}
                            onChange={handleChange}
                            disabled={loading}
                          >
                            <option value="">Selecione...</option>
                            <option value="SOLTEIRO">Solteiro</option>
                            <option value="CASADO">Casado</option>
                            <option value="DIVORCIADO">Divorciado</option>
                            <option value="VIUVO">Viúvo</option>
                            <option value="SEPARADO">Separado</option>
                          </select>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="mb-2">
                          <label className="form-label small fw-semibold">Escolaridade</label>
                          <select
                            className="form-select form-select-sm"
                            name="escolaridade"
                            value={formData.escolaridade}
                            onChange={handleChange}
                            disabled={loading}
                          >
                            <option value="">Selecione...</option>
                            <option value="ANALFABETO">Analfabeto</option>
                            <option value="FUNDAMENTAL INCOMPLETO">Fundamental Incompleto</option>
                            <option value="FUNDAMENTAL COMPLETO">Fundamental Completo</option>
                            <option value="MEDIO INCOMPLETO">Médio Incompleto</option>
                            <option value="MEDIO COMPLETO">Médio Completo</option>
                            <option value="SUPERIOR INCOMPLETO">Superior Incompleto</option>
                            <option value="SUPERIOR COMPLETO">Superior Completo</option>
                            <option value="POS GRADUACAO">Pós-Graduação</option>
                          </select>
                        </div>
                      </div>
                    </div>

                    <div className="row gx-2">
                      <div className="col-md-2">
                        <div className="mb-2">
                          <label className="form-label small fw-semibold">RG</label>
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            name="rgNum"
                            value={formData.rgNum}
                            onChange={handleChange}
                            maxLength={20}
                            placeholder="Nº do RG"
                            disabled={loading}
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="mb-2">
                          <label className="form-label small fw-semibold">RG Expedidor</label>
                          <select
                            className="form-select form-select-sm"
                            name="rgExpedidor"
                            value={formData.rgExpedidor}
                            onChange={handleChange}
                            disabled={loading}
                          >
                            <option value="">Selecione...</option>
                            {emissores.map(e => (
                              <option key={e.codigo} value={e.codigo}>{e.codigo} - {e.nome}</option>
                            ))}
                          </select>
                        </div>
                      </div>
                      <div className="col-md-2">
                        <div className="mb-2">
                          <label className="form-label small fw-semibold">RG UF</label>
                          <select
                            className="form-select form-select-sm"
                            name="rgUf"
                            value={formData.rgUf}
                            onChange={handleChange}
                            disabled={loading}
                          >
                            <option value="">Selecione...</option>
                            <option value="AC">AC</option>
                            <option value="AL">AL</option>
                            <option value="AM">AM</option>
                            <option value="AP">AP</option>
                            <option value="BA">BA</option>
                            <option value="CE">CE</option>
                            <option value="DF">DF</option>
                            <option value="ES">ES</option>
                            <option value="GO">GO</option>
                            <option value="MA">MA</option>
                            <option value="MG">MG</option>
                            <option value="MS">MS</option>
                            <option value="MT">MT</option>
                            <option value="PA">PA</option>
                            <option value="PB">PB</option>
                            <option value="PE">PE</option>
                            <option value="PI">PI</option>
                            <option value="PR">PR</option>
                            <option value="RJ">RJ</option>
                            <option value="RN">RN</option>
                            <option value="RO">RO</option>
                            <option value="RR">RR</option>
                            <option value="RS">RS</option>
                            <option value="SC">SC</option>
                            <option value="SE">SE</option>
                            <option value="SP">SP</option>
                            <option value="TO">TO</option>
                          </select>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="mb-2">
                          <label className="form-label small fw-semibold">Nacionalidade</label>
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            name="nacionalidade"
                            value={formData.nacionalidade}
                            onChange={handleChange}
                            maxLength={30}
                            placeholder="Brasileiro"
                            disabled={loading}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="row gx-2">
                      <div className="col-md-6">
                        <div className="mb-2">
                          <label className="form-label small fw-semibold">Profissão</label>
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            name="profissao"
                            value={formData.profissao}
                            onChange={handleChange}
                            maxLength={50}
                            placeholder="Profissão"
                            disabled={loading}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="row gx-2">
                      <div className="col-md-6">
                        <div className="mb-2">
                          <label className="form-label small fw-semibold">Nome do Pai</label>
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            name="nomePai"
                            value={formData.nomePai}
                            onChange={handleChange}
                            maxLength={100}
                            placeholder="Nome do pai"
                            disabled={loading}
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-2">
                          <label className="form-label small fw-semibold">Nome da Mãe</label>
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            name="nomeMae"
                            value={formData.nomeMae}
                            onChange={handleChange}
                            maxLength={100}
                            placeholder="Nome da mãe"
                            disabled={loading}
                          />
                        </div>
                      </div>
                    </div>
                  </>
                )}

                {formData.tipo === 'PJ' && (
                  <>
                    <h6 className="text-primary mb-2 mt-3">
                      <i className="bi bi-building me-2"></i>
                      Dados da Pessoa Jurídica
                    </h6>

                    <div className="row gx-2">
                      <div className="col-md-3">
                        <div className="mb-2">
                          <label className="form-label small fw-semibold">Porte da Empresa</label>
                          <select
                            className="form-select form-select-sm"
                            name="porteEmpresa"
                            value={formData.porteEmpresa}
                            onChange={handleChange}
                            disabled={loading}
                          >
                            <option value="">Selecione...</option>
                            <option value="MEI">MEI</option>
                            <option value="ME">ME</option>
                            <option value="EPP">EPP</option>
                            <option value="EIRELI">EIRELI</option>
                            <option value="LTDA">LTDA</option>
                            <option value="SA">SA</option>
                            <option value="DEMAIS">DEMAIS</option>
                          </select>
                        </div>
                      </div>
                      <div className="col-md-2">
                        <div className="mb-2">
                          <label className="form-label small fw-semibold">Inscrição Estadual</label>
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            name="inscricaoEstadual"
                            value={formData.inscricaoEstadual}
                            onChange={handleChange}
                            maxLength={30}
                            placeholder="Inscrição Estadual"
                            disabled={loading}
                          />
                        </div>
                      </div>
                      <div className="col-md-2">
                        <div className="mb-2">
                          <label className="form-label small fw-semibold">Inscrição Municipal</label>
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            name="inscricaoMunicipal"
                            value={formData.inscricaoMunicipal}
                            onChange={handleChange}
                            maxLength={30}
                            placeholder="Inscrição Municipal"
                            disabled={loading}
                          />
                        </div>
                      </div>
                      <div className="col-md-5">
                        <div className="mb-2">
                          <label className="form-label small fw-semibold">Nome Fantasia</label>
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            name="nomeFantasia"
                            value={formData.nomeFantasia}
                            onChange={handleChange}
                            maxLength={100}
                            placeholder="Nome fantasia"
                            disabled={loading}
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-2">
                          <label className="form-label small fw-semibold">Atividade Principal</label>
                          <div className="input-group input-group-sm">
                            <input
                              type="text"
                              className="form-control form-control-sm"
                              name="idCnae"
                              value={formData.idCnae ? `${formData.idCnae.replace(/\D/g, '')}${(() => { const c = cnaes.find(x => x.codigo === formData.idCnae); return c ? ` - ${c.descricao}` : ''; })()}` : ''}
                              readOnly
                              placeholder="Selecione um CNAE"
                            />
                            <button
                              type="button"
                              className="btn btn-outline-info btn-sm"
                              onClick={() => setShowCnaePicker(true)}
                              disabled={loading || cnaesLoading}
                              title="Selecionar CNAE"
                            >
                              <i className="bi bi-search"></i>
                            </button>
                            {formData.idCnae && (
                              <button
                                type="button"
                                className="btn btn-outline-secondary btn-sm"
                                onClick={() => setFormData(prev => ({ ...prev, idCnae: '' }))}
                                title="Limpar CNAE"
                              >
                                <i className="bi bi-x"></i>
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-2">
                          <label className="form-label small fw-semibold">Natureza Jurídica</label>
                          <div className="input-group input-group-sm">
                            <input
                              type="text"
                              className="form-control form-control-sm"
                              name="idNaturezaJuridica"
                              value={formData.idNaturezaJuridica ? `${formData.idNaturezaJuridica}${(() => { const n = naturezas.find(x => x.codigo === formData.idNaturezaJuridica); return n ? ` - ${n.descricao}` : ''; })()}` : ''}
                              readOnly
                              placeholder="Selecione uma Natureza Jurídica"
                            />
                            <button
                              type="button"
                              className="btn btn-outline-info btn-sm"
                              onClick={() => setShowNaturezaJuridicaPicker(true)}
                              disabled={loading || naturezasLoading}
                              title="Selecionar Natureza Jurídica"
                            >
                              <i className="bi bi-search"></i>
                            </button>
                            {formData.idNaturezaJuridica && (
                              <button
                                type="button"
                                className="btn btn-outline-secondary btn-sm"
                                onClick={() => setFormData(prev => ({ ...prev, idNaturezaJuridica: '' }))}
                                title="Limpar Natureza Jurídica"
                              >
                                <i className="bi bi-x"></i>
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                )}

                <h6 className="text-primary mb-2 mt-3">
                  <i className="bi bi-telephone me-2"></i>
                  Contato
                </h6>

                <div className="row gx-2">
                  <div className="col-md-4">
                    <div className="mb-2">
                      <label className="form-label small fw-semibold">E-mail</label>
                      <input
                        type="email"
                        className="form-control form-control-sm"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        maxLength={100}
                        placeholder="email@exemplo.com"
                        disabled={loading}
                      />
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="mb-2">
                      <label className="form-label small fw-semibold">Telefone</label>
                      <TelefoneMaskInput
                        value={formatTelefone(formData.telefone)}
                        onChange={e =>
                          handleChange({
                            target: {
                              name: 'telefone',
                              value: e.target.value,
                            },
                          })
                        }
                        name="telefone"
                      />
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="mb-2">
                      <label className="form-label small fw-semibold">Celular</label>
                      <CelularMaskInput
                        value={formatCelular(formData.celular)}
                        onChange={e =>
                          handleChange({
                            target: {
                              name: 'celular',
                              value: e.target.value,
                            },
                          })
                        }
                        name="celular"
                      />
                    </div>
                  </div>
                </div>

                <h6 className="text-primary mb-2 mt-3">
                  <i className="bi bi-geo-alt me-2"></i>
                  Endereço
                </h6>

                <div className="row gx-2">
                  <div className="col-md-5">
                    <div className="mb-2">
                      <label className="form-label small fw-semibold">Logradouro</label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        name="logrNome"
                        value={formData.logrNome}
                        onChange={handleChange}
                        maxLength={70}
                        placeholder="Rua, Avenida, etc."
                        disabled={loading}
                      />
                    </div>
                  </div>
                  <div className="col-md-1">
                    <div className="mb-2">
                      <label className="form-label small fw-semibold">Número</label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        name="logrNum"
                        value={formData.logrNum}
                        onChange={handleChange}
                        maxLength={10}
                        placeholder="Nº"
                        disabled={loading}
                      />
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="mb-2">
                      <label className="form-label small fw-semibold">Complemento</label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        name="logrCompl"
                        value={formData.logrCompl}
                        onChange={handleChange}
                        maxLength={70}
                        placeholder="Apto, Sala, etc."
                        disabled={loading}
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="mb-2">
                      <label className="form-label small fw-semibold">Bairro</label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        name="logrBairro"
                        value={formData.logrBairro}
                        onChange={handleChange}
                        maxLength={70}
                        placeholder="Bairro"
                        disabled={loading}
                      />
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="mb-2">
                      <label className="form-label small fw-semibold">CEP</label>
                      <CEPMaskInput
                        value={formatCEP(formData.logrCep)}
                        onChange={e =>
                          handleChange({
                            target: {
                              name: 'logrCep',
                              value: e.target.value,
                            },
                          })
                        }
                        name="logrCep"
                      />
                    </div>
                  </div>
                  <div className="col-md-1">
                    <div className="mb-2">
                      <label className="form-label small fw-semibold">UF</label>
                      <select
                        className="form-select form-select-sm"
                        name="logrUf"
                        value={formData.logrUf}
                        onChange={handleChange}
                        disabled={loading}
                      >
                        <option value="">--</option>
                        {ufs.map(uf => (
                          <option key={uf} value={uf}>
                            {uf}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="col-md-5">
                    <div className="mb-2">
                      <label className="form-label small fw-semibold">Cidade</label>
                      <select
                        className="form-select form-select-sm"
                        name="logrCidade"
                        value={formData.logrCidade}
                        onChange={handleChange}
                        disabled={loading || !formData.logrUf}
                      >
                        <option value="">Selecione uma cidade...</option>
                        {cidades.map((cidade, index) => (
                          <option key={index} value={cidade.nome}>
                            {cidade.nome}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>

                <h6 className="text-primary mb-2 mt-3">
                  <i className="bi bi-bank me-2"></i>
                  Dados Bancários
                </h6>

                <div className="row gx-2">
                  <div className="col-md-4">
                    <div className="mb-2">
                      <label className="form-label small fw-semibold">Banco</label>
                      <div className="input-group input-group-sm">
                        <input
                          type="text"
                          className="form-control form-control-sm"
                          value={formData.banco}
                          readOnly
                          placeholder="Clique para selecionar"
                        />
                        <button
                          className="btn btn-outline-secondary btn-sm"
                          type="button"
                          onClick={() => setShowBancoPicker(true)}
                        >
                          <i className="bi bi-search"></i>
                        </button>
                        {formData.banco && (
                          <button
                            className="btn btn-outline-danger btn-sm"
                            type="button"
                            onClick={() => setFormData(prev => ({ ...prev, banco: '' }))}
                          >
                            <i className="bi bi-x-lg"></i>
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-1">
                    <div className="mb-2">
                      <label className="form-label small fw-semibold">Agência</label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        name="agencia"
                        value={formData.agencia}
                        onChange={handleChange}
                        maxLength={20}
                        placeholder="Agência"
                        disabled={loading}
                      />
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="mb-2">
                      <label className="form-label small fw-semibold">Conta</label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        name="conta"
                        value={formData.conta}
                        onChange={handleChange}
                        maxLength={20}
                        placeholder="Nº da conta"
                        disabled={loading}
                      />
                    </div>
                  </div>
                </div>

                </form>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary btn-sm"
                onClick={onClose}
                disabled={loading || loadingFornecedor}
              >
                <i className="bi bi-x-circle me-1"></i>
                Cancelar
              </button>
              <button
                type="submit"
                className="btn btn-primary btn-sm"
                onClick={handleSubmit}
                disabled={loading || loadingFornecedor}
              >
                {loading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-1"></span>
                    Salvando...
                  </>
                ) : (
                  <>
                    <i className="bi bi-check-circle me-1"></i>
                    Salvar
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      <CnaePicker
        show={showCnaePicker}
        cnaes={cnaes}
        selectedCodigo={formData.idCnae}
        onSelect={c => {
          setFormData(prev => ({ ...prev, idCnae: c.codigo }));
          setShowCnaePicker(false);
        }}
        onClose={() => { setShowCnaePicker(false); }}
      />
      <BancoPicker
        show={showBancoPicker}
        bancos={bancos}
        selectedNome={formData.banco}
        onSelect={b => {
          setFormData(prev => ({ ...prev, banco: b.nome }));
          setShowBancoPicker(false);
        }}
        onClose={() => { setShowBancoPicker(false); }}
      />
      <NaturezaJuridicaPicker
        show={showNaturezaJuridicaPicker}
        naturezas={naturezas}
        selectedCodigo={formData.idNaturezaJuridica}
        onSelect={n => {
          setFormData(prev => ({ ...prev, idNaturezaJuridica: n.codigo }));
          setShowNaturezaJuridicaPicker(false);
        }}
        onClose={() => { setShowNaturezaJuridicaPicker(false); }}
      />
      <DefaultModal {...setDefaultModal} />
      </div>
    </>
  );
}

export default FornecedorModal;
